<template>
    <div>
        <slot />
    </div>
</template>

<script>
import Vue from 'vue';
import $ from 'jquery';

export default Vue.extend({
  name: 'botsplash-provider',

  data() {
    return {
      isWidgetLoaded: false,
      lastAuthState: null,
      activeContactId: null,
    };
  },

  mounted() {
    this.handleBotsplash();
    this.boundHandleClickEvent = this.handleClickEvent.bind(this);
    document.addEventListener('click', this.boundHandleClickEvent, true);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.boundHandleClickEvent, true);
  },
  methods: {
    handleClickEvent(event) {
      if (event.target.closest('.js-logout-btn')) {
        this.logoutBotsplash();
      }
    },

    handleUrlChange() {
      const match = window.location.pathname.match(/^\/contact\/(.+)/);
      if (match) {
        this.onContactSet(match[1]);
      } else {
        this.onContactClear();
      }
    },

    async onContactSet(contactId) {
      if (this.activeContactId === contactId) return;

      this.activeContactId = contactId;
      await this.handleBotsplash();
    },

    async onContactClear() {
      if (!this.activeContactId) return;

      this.activeContactId = null;
      await this.handleBotsplash();
    },

    async handleBotsplash() {
      try {
      const isLoggedIn = !!window.user;

      if (this.lastAuthState === isLoggedIn) return;
      this.lastAuthState = isLoggedIn;

      this.handleUrlChange();

      const tokenInfo = await this.generateBotsplashToken();

      if (isLoggedIn && !this.isWidgetLoaded) {
        if (!tokenInfo) {
            return;
        }
        window.BSPDASHBOARD_APP_URL = tokenInfo?.account_url;
        await this.loadBotsplashScript(tokenInfo, this.activeContactId);
        this.isWidgetLoaded = true;
      }

      if (!isLoggedIn && this.isWidgetLoaded) {
        this.isWidgetLoaded = false;
      }
     } catch (error) {
      console.error('Error handling Botsplash integration:', error);
     }
    },
    async loadBotsplashScript(tokenInfo) {
      try {
      const script = document.createElement('script');
      script.src = `${window.BSPDASHBOARD_APP_URL}/y.js`;
      script.async = true;

      script.onerror = () => {
        throw new Error('Failed to load Botsplash script');
      };

      script.onload = async () => {
       try {
        if (tokenInfo && window.$bspdashboard) {
          window.$bspdashboard.remove(true);
          await new Promise((r) => setTimeout(r, 500));
          const widgetUrl = this.activeContactId ? `${tokenInfo.account_url}?clientVisitorId=${this.activeContactId}`
                             : tokenInfo.account_url;
             window.$bspdashboard.loginAccount(this.getAccountName(tokenInfo.account_url), tokenInfo.token, widgetUrl);

             if (this.activeContactId) {
                await this.waitForBotsplashMethod('loadVisitor');
                console.log('available methods on $bspdashboard after login:', Object.keys(window.$bspdashboard));
                window.$bspdashboard.loadVisitor(this.activeContactId);
            }
        }
       } catch (err) {
        console.error('Error during Botsplash login:', err);
       }
      };

      document.head.appendChild(script);
     } catch (error) {
      console.error('Error loading Botsplash script:', error);
     }
    },
    getAccountName(accountUrl) {
    if (accountUrl) {
      return accountUrl.split('//')[1].split('.')[0];
      }
      return null;
    },

    // Utility function to wait for the loadVisitor method to be available on $bspdashboard, since initial load of the dashboard widget takes time
    async waitForBotsplashMethod(methodName, maxWait = 3000) {
      const start = Date.now();
      const checkInterval = 100;

      while (!window.$bspdashboard?.[methodName]) {
        if (Date.now() - start > maxWait) {
          throw new Error(`Botsplash method '${methodName}' not available after ${maxWait}ms`);
        }
        // eslint-disable-next-line no-await-in-loop
        await new Promise((r) => setTimeout(r, checkInterval));
      }
    },

    generateBotsplashToken() {
      return new Promise((resolve, reject) => {
        $.ajax({
          url: '/integration/botsplash-token',
          method: 'GET',
          global: false,
          crossDomain: true,
        })
         .done((data, textStatus, xhr) => {
            if (xhr.status === 204) {
            console.log('Botsplash permission is not granted for this user');
            } else {
            resolve(data);
            }
        })
        .fail(reject);
      });
    },
    async logoutBotsplash() {
      if (window.$bspdashboard && typeof window.$bspdashboard.logout === 'function') {
        try {
          window.$bspdashboard.logout();
        } catch (err) {
          console.error('Error logging out from Botsplash:', err);
        }
      }
    },
  },
});
</script>
